<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="handleCancelButtonClick">
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('caseDetails.case.title') }} {{ viewedCase.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
            <div>
                <table>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.caseInDp.label') }}</strong></td>
                        <td v-if="!viewedCase.dpId">{{ viewedCase.title | NoEmpty}}</td>
                        <td v-else><a :href="this.fetchDPUrl + 'cases/' + viewedCase.dpId" target="_blank" @click.stop=''>{{
                            viewedCase.title}}</a></td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.caseCreationDatetime.label') }}</strong></td><td><span>{{ viewedCase.creationDatetime | DateWithMinutes | NoEmpty}}</span></td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.periodExecution.label') }}</strong></td><td><span>{{ viewedCase.periodExecution }}</span></td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.receiptMaterialsDatetime.label') }}</strong></td><td><span>{{ viewedCase.receiptMaterialsDatetime | DateWithMinutes | NoEmpty}}</span></td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.materialsReturnedDate.label') }}</strong></td><td>{{ viewedCase.materialsReturnedDate | NoEmpty}}</td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.patientName.label') }}</strong></td><td>{{ viewedCase.patientName | NoEmpty}}</td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.patientPhone.label') }}</strong></td><td>{{ viewedCase.patientPhone | NoEmpty}}</td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.patientAddress.label') }}</strong></td><td>{{ viewedCase.patientAddress | NoEmpty}}</td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.patientEmail.label') }}</strong></td><td>{{ viewedCase.patientEmail | NoEmpty}}</td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.outgoingDiagnosis.label') }}</strong></td><td><span>{{ viewedCase.outgoingDiagnosis | NoEmpty }}</span></td>
                    </tr>
                    <!--<tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.price.label') }}</strong></td><td><span>{{ viewedCase.price | currency | NoEmpty}}</span></td>
                    </tr>-->
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.clientSpecialist.label') }}</strong></td><td> {{ clientSpecialistName | NoEmpty}} </td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.holdHistory.label') }}</strong></td>
                        <td>
                            <table class="v-table table-striped" v-if="holdHistoryVisible">
                                <thead>
                                <tr>
                                    <th>{{ $t('caseDetails.holdHistory.start.label') }}</th>
                                    <th>{{ $t('caseDetails.holdHistory.finish.label') }}</th>
                                    <th>{{ $t('caseDetails.holdHistory.reason.label') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="hold in viewedCase.holdHistory" :key="hold.start + '-' + hold.reason">
                                    <td>{{ hold.start | DateWithMinutes | NoEmpty }}</td>
                                    <td>{{ hold.finish | DateWithMinutes | NoEmpty }}</td>
                                    <td>{{ hold.reason }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <span v-else>
                {{ $t('caseDetails.holdHistory.noHistory.label') }}
              </span>
                        </td>
                    </tr>
                    <tr>
                        <td class="case-param-name"><strong>{{ $t('caseDetails.ecdcHistory.label') }}</strong></td>
                        <td>
                            <table class="v-table table-striped" v-if="ecdcHistoryVisible">
                                <thead>
                                <tr>
                                    <th>{{ $t('caseDetails.ecdcHistory.date.label') }}</th>
                                    <th>{{ $t('caseDetails.ecdcHistory.hours.label') }}</th>
                                    <th>{{ $t('caseDetails.ecdcHistory.reason.label') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="ecdcItem in viewedCase.ecdcHistory" :key="ecdcItem.correctionDatetime + '-' + ecdcItem.reason">
                                    <td>{{ ecdcItem.correctionDatetime | DateWithMinutes | NoEmpty }}</td>
                                    <td>{{ ecdcItem.hours }}</td>
                                    <td>{{ ecdcItem.reason }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <span v-else>
               {{ $t('caseDetails.ecdcHistory.noHistory.label') }}
              </span>
                        </td>
                    </tr>
                </table>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
  import NoEmpty from '../Filters/NoEmpty.js'
  import DateWithMinutes from '../Filters/DateWithMinutes.js'
  import _ from 'lodash'
  import {mapState} from "vuex";

  export default {
    name: 'case-details',
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    components: {
    },
    props: {
      specialists: {
        type: Array
      },
      viewedCase: {
        type: Object
      },
    },
    data () {
      return {

      }
    },
    computed: {
      ...mapState({fetchDPUrl: state => state.dpURL}),
      holdHistoryVisible () {
        return this.viewedCase.holdHistory && this.viewedCase.holdHistory.length > 0
      },
      ecdcHistoryVisible () {
        return this.viewedCase.ecdcHistory && this.viewedCase.ecdcHistory.length > 0
      },
      clientSpecialistName () {
        let index = _.findIndex(this.specialists, (item) => {
          return item.id === this.viewedCase.clientSpecialistId
        })

        if (index < 0) {
          return '-'
        }

        return this.specialists[index].name
      },
    },
    methods: {
      handleCancelButtonClick () {
        this.$emit('close')
      },
      getItemDataByPath (item, path) {
        return _.get(item, path, '-')
      }
    }
  }
</script>

<style>
    .case-param-name {
        min-width: 320px;
    }
</style>
